<div class="app-page__wrapper">
  <div class="app-page-header__wrapper">
    <header class="app-page-header__header app-primary-header app-page-header">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h1 class="app-page-header__title mat-h1">{{titleSrvice.title}} </h1>
        @if ((isScreenSmall|async)) {
          <ng-content select=".menuaction"></ng-content>
        }
      </div>
    </header>
    <ng-content></ng-content>
  </div>
</div>